import React, { useEffect, useState } from 'react';
import classes from "./ConfirmationPage.module.css";
import Header from '../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmSubAPI, login } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import SmallLoader from '../components/Loaders/SmallLoader';
import { useTranslation } from 'react-i18next';

const ConfirmationPage = () => {

    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [msisdn, setMsisdn] = useState(null);
    const [extRef, setExtRef] = useState(null);
    const [pack, setPack] = useState(null);
    const [packNo, setPackNo] = useState(null);

    const { selectedLanguage } = useSelector(state => state.languageSlice);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setPack(location?.state?.pack);
            setPackNo(location?.state?.packNo);
        }
        else {
            navigate("/");
        }
    }, [location]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);

            const response = await confirmSubAPI(msisdn, extRef, pack);
            setLoading(false);

            if (response?.data?.status == 4) {
                toast.success(t("90"));
            }

            if (response?.data?.status == 3) {
                // toast.success(t("91"));
                navigate("/low-balance");
                return;
            }

            await login({ msisdn: msisdn })
                .then((res) => {
                    setLoading(false);
                    dispatch(setUserToken(res?.data?.result?.token));
                    navigate("/home", { replace: true, state: null });
                    toast.success(t("84"));
                })
                .catch((err) => {
                    setLoading(false);
                    toast.error(t("92"));
                });
        } catch (error) {
            setLoading(false);
            if (error?.response?.data?.status == 0) {
                toast.error(t("93"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.error(t("94"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    return (
        <>
            <Header />
            <div className={classes.container}>
                <div className={classes.description}>
                    <h2 className={classes.title}>{t("76")}</h2>
                    {selectedLanguage == "0" || selectedLanguage == "1" ?
                        <p className={classes.text}>
                            {packNo == "50" ? t("354") : t("355")}
                        </p>
                        : 
                          <p className={classes.text}>
                            {t("77")} <span className={classes.bold}>{packNo == "50" ? t("131") : t("132")}</span>.{" "}
                            {t("79")}
                        </p>
                        }

                    {/* {selectedLanguage != "0" || selectedLanguage != "1" &&
                        <p className={classes.text}>
                            {t("77")} <span className={classes.bold}>{packNo == "50" ? t("131") : t("132")}</span>.{" "}
                            {t("79")}
                        </p>
                    } */}

                </div>

                <div className={classes.buttons_container}>
                    <button type='button' disabled={loading} className={classes.button} onClick={handleFormSubmission}>
                        {loading ? <SmallLoader /> : t("80")}
                    </button>
                    <button type='button' disabled={loading} className={classes.no_button} onClick={() => navigate("/")}>
                        {t("81")}
                    </button>
                </div>
            </div>
        </>

    )
}

export default ConfirmationPage